import { connect } from 'react-redux';
import InputModalReadyProducts from './InputModalSavedProducts';
import {
  setQuantityField,
  setZdvlLineIdField,
  setOperationNumIdField,
  setPieceNumIdField,
  setPieceIdField,
  setQcIdField,
  setQcDateField,
  setThicknessField,
  setProductUnit,
  setProfileSizeField,
  setMarkField,
  setZdvlLineNumId,
  setNormativeDocField,
  setLengthField,
  setReadyProductsPieces,
  setQuantityOff,
  setPlantOperationAttribsInherit,
  getZdvlByTask,
  setCapacityPipe,
  setCapacityAvailable
} from '../../../store/actions/savedProducts';

const mapStateToProps = ({
  userReducer,
  tabsReducer,
  settingsReducer,
  savedProductsReducer
}) => ({
  userReducer,
  tabsReducer,
  settingsReducer,
  savedProductsReducer
});
const mapDispatchToProps = {
  setQuantityField,
  setZdvlLineIdField,
  setOperationNumIdField,
  setLengthField,
  setPieceNumIdField,
  setPieceIdField,
  setQcIdField,
  setQcDateField,
  setZdvlLineNumId,
  setThicknessField,
  setProductUnit,
  setProfileSizeField,
  setReadyProductsPieces,
  setMarkField,
  setQuantityOff,
  setCapacityPipe,
  setCapacityAvailable,
  getZdvlByTask,
  setNormativeDocField,
  setPlantOperationAttribsInherit
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InputModalReadyProducts);
